export interface Profile {
    id: string
    updated_at: Date,
    avatar_url: string
    usage: string,
    completed_onboarding: boolean
}

export enum Plan {
    FREE = "FREE",
    LIFETIME = "LIFETIME",
    PRO = "PRO"
}

export interface SubscriptionResponse {
    plans: Plan[]
}